import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromADM } from 'core/contexts/device-types';
import { AdmSideMenuList } from './adm-side-menu-list.tsx';
import FeatureFlagGuard from 'core/auth/feature-flag-guard.component';
import { AomSideMenuList } from './aom-side-menu-list.tsx';

export const SettingsMenuComponent = () => <SettingsMenuContent />;

const SettingsMenuContent = () => (
    <>
        <AomSideMenuList />
        <FeatureFlagGuard featureFlag="deviceManagementEnabled">
            <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromADM} source={DEVICE_TYPE_SOURCE.ADM}>
                <AdmSideMenuList />
            </DeviceTypesProvider>
        </FeatureFlagGuard>
    </>
);
